var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          attrs: {
            load: _vm.loading,
            data: _vm.list,
            border: true,
            "max-height": _vm.maxHeight,
            size: "small",
            "tooltip-effect": "dark",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "recordTime", label: "操作时间" },
          }),
          _c("el-table-column", {
            attrs: { prop: "operator", label: "操作方" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.operator || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "operatorName", label: "操作人" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.operatorName || scope.row.operateUserName
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "operateTypeMsg", label: "操作类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.operateTypeMsg || scope.row.operateType
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "newRecord", label: "操作内容" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.operateType == 20005
                      ? _vm._l(
                          (scope.row.newRecord || "").split(","),
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: item + "_" + index,
                                staticClass: "image-view",
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-zoom-in icon",
                                }),
                                _c("el-image", {
                                  attrs: {
                                    src: item,
                                    "preview-src-list": (
                                      scope.row.newRecord || ""
                                    ).split(","),
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        )
                      : _c("span", {
                          staticStyle: { "white-space": "pre-wrap" },
                          domProps: {
                            innerHTML: _vm._s(scope.row.newRecord || "无"),
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "oldRecord", label: "原内容" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", {
                      staticStyle: { "white-space": "pre-wrap" },
                      domProps: {
                        innerHTML: _vm._s(scope.row.oldRecord || "无"),
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          void 0,
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }